// extracted by mini-css-extract-plugin
module.exports = {"RequiredAnnotation":"InputLabel_RequiredAnnotation__1wSQ7","Container":"InputLabel_Container__2UdCq","Label":"InputLabel_Label__s9fOF"};